import { css } from "lit";

export const styles = css`
  /* Mobile page title - hidden by default, shown on mobile */
  .mobile-page-title {
    margin: 0 0 var(--sds-size-space-600) 0;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-heading-size);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1.2;
    letter-spacing: -0.4px;
    display: none;
  }

  .unsaved-changes-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    align-items: center;
    wow-button {
      min-width: 250px;
      --wow-button-inner-width: 100%;
    }
  }

  p {
    color: var(--sds-color-text-default-default);
  }

  .danger,
  .danger:hover {
    /* override wow-button background color */
    --sds-color-background-default-secondary: var(--sds-color-background-danger-default);
  }

  .containers {
    display: flex;
    flex-direction: row;
    gap: var(--sds-size-space-600);
    width: 100%;
    flex: 1;
    min-height: 0;
  }

  @media (max-width: 768px) {
    /* Show mobile page title */
    .mobile-page-title {
      display: block;
    }
  }

  .user-info-section {
    overflow: hidden auto;
    height: initial;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .text-field {
    width: 100%;
    padding: var(--sds-size-space-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    background-color: var(--sds-color-background-default-tertiary);
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-scale-02);
    outline: none;
  }

  .text-field:focus {
    border-color: var(--sds-color-border-brand-default);
  }

  .multiline-text-field {
    width: 100%;
    min-height: 100px;
    padding: var(--sds-size-space-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    background-color: var(--sds-color-background-default-tertiary);
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-scale-02);
    resize: vertical;
    outline: none;
  }

  .multiline-text-field:focus {
    border-color: var(--sds-color-border-brand-default);
  }

  /* Social media modal layout */
  .social-links-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--sds-size-space-600);
    overflow: auto;
  }

  /* Mobile-first: single column by default for small screens */
  @media (max-width: 767px) {
    .social-links-content {
      display: flex !important;
      flex-direction: column;
      gap: var(--sds-size-space-300);
    }

    .user-info-section {
      overflow: initial;
    }

    [slot="column"] {
      flex: none;
      min-height: fit-content;
    }
  }

  /* Social media modal columns styling */
  .column-left,
  .column-right {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
  }

  /* Respect user motion preferences */
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  .profile-content-container {
    overflow-y: auto;
  }
`;
